const { NODE_ENV } = process.env;

export const isDevelopment = NODE_ENV === "development";

export const API_URL = window.location.origin;

export const INCEPTION_DATE = "2009-01-01";

export const INSTALLATION_CURRENCY = "NOK";

export const BANK_APPROVED = "" //"AB_KA"; Whatever tag AB uses to mark accounts as approved

export const APPROVED_PORTFOLIO = "KAR-Approved" //"AB_KA"; Whatever tag AB uses to mark accounts as approved

export const ASK_PORTFOLIO_CODE = "ASK"

export const ASK_APPROVED_FUNDS = ["EF"]

export const BASE_MAX_SALE = 0.9